import React from 'react';
import Grid from 'components/atoms/Grid';
import Select from 'components/atoms/Select';
import CostTable from './CostTable';
import ShippingTable from './ShippingTable';

const EstimateItem = ({
  item,
  index,
  isView,
  updateItem,
  removeItem,
  addTier,
  removeTier,
  updateTierQty,
  vendorCosts,
  updateCost,
  shippingData,
  updateShipping,
  itemSelectedTiers,
  setItemSelectedTiers,
  options,
  vendors,
  shippingMethods,
  fmt,
}) => {
  const selectedTierIds = itemSelectedTiers[item.id] || [item.tiers[0]?.id];

  return (
    <div className="item-card">
      <div className="item-number">{index + 1}</div>

      {/* ── Section 1: Product Details ── */}
      <div className="item-details-col" style={{ width: '100%' }}>
        <div className="item-header-row">
          <div className="d-flex align-items-center gap-3">
            <div className="item-image-placeholder" style={{ width: 48, height: 48 }}>
              <i className="material-icons-outlined" style={{ fontSize: 24 }}>
                inventory_2
              </i>
            </div>
            <input
              type="text"
              className="item-name-input"
              value={item.name}
              disabled={isView}
              onChange={e => updateItem(item.id, 'name', e.target.value)}
            />
          </div>
          <div className="item-actions">
            {!isView && (
              <button type="button" className="btn-icon text-danger" onClick={() => removeItem(item.id)}>
                <i className="material-icons-outlined">delete_outline</i> Remove
              </button>
            )}
          </div>
        </div>

        <Grid xs={1} lg={4} colGap={16} className="mt-2">
          <div>
            <span className="label-text">Packaging Type</span>
            <Select
              sm
              disabled={isView}
              options={options.packagingType}
              value={options.packagingType.find(o => o.value === item.packagingType)}
              onChange={({ target }) => updateItem(item.id, 'packagingType', target.value?.value)}
            />
          </div>
          <div>
            <span className="label-text">Printing Details</span>
            <Select
              sm
              disabled={isView}
              options={options.print}
              value={options.print.find(o => o.value === item.printing)}
              onChange={({ target }) => updateItem(item.id, 'printing', target.value?.value)}
            />
          </div>
          <div>
            <span className="label-text">Finishes</span>
            <Select
              sm
              disabled={isView}
              options={options.finish}
              value={options.finish.find(o => o.value === item.finishes)}
              onChange={({ target }) => updateItem(item.id, 'finishes', target.value?.value)}
            />
          </div>
          <div>
            <span className="label-text">Lamination</span>
            <Select
              sm
              disabled={isView}
              options={options.lamination}
              value={options.lamination.find(o => o.value === item.lamination)}
              onChange={({ target }) => updateItem(item.id, 'lamination', target.value?.value)}
            />
          </div>
        </Grid>

        <Grid xs={1} lg={4} colGap={16} className="mt-3">
          <div className="qty-section">
            <span className="label-text">Quantity Tiers</span>
            <Grid xs={1} lg={4} gap={15} className="mb-20">
              {item.tiers.map((tier, tIdx) => (
                <div key={tier.id} className="tier-input-group">
                  <span className="label-text">Tier {tIdx + 1}</span>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      type="number"
                      className="cost-input "
                      style={{ width: 60 }}
                      value={tier.quantity}
                      disabled={isView}
                      onChange={e => updateTierQty(item.id, tier.id, e.target.value)}
                    />
                    {item.tiers.length > 1 && !isView && (
                      <button type="button" className="text-danger" onClick={() => removeTier(item.id, tier.id)}>
                        <i className="material-icons-outlined" style={{ fontSize: 16 }}>
                          cancel
                        </i>
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </Grid>
            {!isView && (
              <button type="button" className="btn-add" onClick={() => addTier(item.id)}>
                + Add Tier
              </button>
            )}
          </div>
          <div>
            <span className="label-text">Stock</span>
            <Select
              sm
              disabled={isView}
              options={options.stock}
              value={options.stock.find(o => o.value === item.stock)}
              onChange={({ target }) => updateItem(item.id, 'stock', target.value?.value)}
            />
          </div>
          <div>
            <span className="label-text">Unit Weight (kg)</span>
            <input
              type="number"
              step="0.001"
              className="cost-input w-100"
              placeholder="0.000"
              value={item.unitWeight}
              disabled={isView}
              onChange={e => updateItem(item.id, 'unitWeight', e.target.value)}
            />
          </div>
          <div>
            <span className="label-text">Dimensions</span>
            <Grid xs={4} colGap={6}>
              <input
                className="cost-input w-100"
                placeholder="L"
                value={item.dimLength}
                disabled={isView}
                onChange={e => updateItem(item.id, 'dimLength', e.target.value)}
              />
              <input
                className="cost-input w-100"
                placeholder="W"
                value={item.dimWidth}
                disabled={isView}
                onChange={e => updateItem(item.id, 'dimWidth', e.target.value)}
              />
              <input
                className="cost-input w-100"
                placeholder="H"
                value={item.dimHeight}
                disabled={isView}
                onChange={e => updateItem(item.id, 'dimHeight', e.target.value)}
              />
              <select
                className="cost-input w-100"
                value={item.dimUnit}
                disabled={isView}
                onChange={e => updateItem(item.id, 'dimUnit', e.target.value)}>
                {options.unit.map(o => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            </Grid>
          </div>
        </Grid>
      </div>

      {/* ── Section 2: Estimation Tables ── */}
      <div className="item-input-col">
        <div className="tables-grid">
          <CostTable item={item} isView={isView} vendorCosts={vendorCosts} updateCost={updateCost} vendors={vendors} />
          <ShippingTable
            item={item}
            isView={isView}
            shippingData={shippingData}
            updateShipping={updateShipping}
            vendors={vendors}
            shippingMethods={shippingMethods}
          />
        </div>
      </div>

      {/* ── Section 3: Margin, Vendors & Tiers ── */}
      <div className="item-summary-footer mt-4" style={{ borderTop: '2px solid #eef2ff', paddingTop: 24 }}>
        <h4>Summary</h4>

        <Grid sm={1} lg={2} gap={50} className="mb-20">
          <div>
            <span className="label-text font-weight-bold">Select Active Vendors</span>
            <div className="card-vendor-select">
              {vendors.map(v => {
                const isActive = item.selectedVendors?.includes(v.key);
                return (
                  <div
                    key={v.key}
                    className={`vendor-opt ${v.key} ${isActive ? 'active' : ''}`}
                    onClick={() => {
                      if (isView) return;
                      const current = item.selectedVendors || [];
                      const next = isActive ? current.filter(k => k !== v.key) : [...current, v.key];
                      updateItem(item.id, 'selectedVendors', next);
                    }}>
                    {v.flagImg && <img src={v.flagImg} alt={v.short} style={{ width: 16, height: 12 }} />}
                    {v.label}
                  </div>
                );
              })}
            </div>
          </div>

          <div>
            <div className="item-margin-controls">
              <div className="margin-header" style={{ marginBottom: 4 }}>
                <span className="label" style={{ fontSize: 13, color: '#475569' }}>
                  Adjust Profit Margin
                </span>
                <span className="value" style={{ fontSize: 14 }}>
                  {item.margin || 50}%
                </span>
              </div>
              <div className="slider-wrapper">
                <span>30%</span>
                <input
                  type="range"
                  min="30"
                  max="100"
                  step="5"
                  disabled={isView}
                  value={item.margin || 50}
                  onChange={e => updateItem(item.id, 'margin', parseInt(e.target.value))}
                />
                <span>100%</span>
              </div>
            </div>
          </div>
        </Grid>
        <div className="mb-20">
          <span className="label-text font-weight-bold">Select Tiers for Summary</span>
          <div className="tiers-selection-list">
            {item.tiers.map((t, i) => {
              const isChecked = selectedTierIds.includes(t.id);
              return (
                <label key={t.id} className="tier-checkbox-label">
                  <input
                    type="checkbox"
                    checked={isChecked}
                    disabled={isView}
                    onChange={e => {
                      if (isView) return;
                      let next;
                      if (e.target.checked) {
                        next = [...selectedTierIds, t.id];
                      } else {
                        next = selectedTierIds.filter(id => id !== t.id);
                      }
                      setItemSelectedTiers(prev => ({ ...prev, [item.id]: next }));
                    }}
                  />
                  <span>
                    Tier {i + 1} ({t.quantity} pcs)
                  </span>
                </label>
              );
            })}
          </div>
        </div>

        {/* ── Section 4: Summary Cards (Full Width 100%) ── */}
        <div className="summary-cards-container mt-4" style={{ width: '100%' }}>
          {item.selectedVendors?.flatMap(vKey => {
            return selectedTierIds.map(tierId => {
              const vendor = vendors.find(v => v.key === vKey);
              const tierIdx = item.tiers.findIndex(t => t.id === tierId);
              const activeTier = item.tiers[tierIdx] || item.tiers[0];
              const qty = Number(activeTier?.quantity) || 0;

              // 1. TOTAL COST
              const vCost = Number(vendorCosts[item.id]?.[vKey]?.[activeTier?.id] || 0);
              const prodTotal = vCost * qty;
              const sRate = Number(shippingData[item.id]?.[vKey]?.[activeTier?.id]?.ratePerKg || 0);
              const sTotal = (Number(item.unitWeight) || 0) * qty * sRate;
              const totalCost = prodTotal + sTotal;

              // 2. Cost PER Unit
              const costPerUnit = qty > 0 ? totalCost / qty : 0;

              // 3. Profit
              const marginPercent = item.margin || 50;
              const profit = totalCost * (marginPercent / 100);

              // 4. Total Amount
              const totalAmount = totalCost + profit;

              // 5. Price Per Unit
              const pricePerUnit = qty > 0 ? totalAmount / qty : 0;

              return (
                <div
                  className="summary-grid mb-3"
                  key={`${vKey}-${tierId}`}
                  style={{
                    padding: '20px',
                    borderRadius: '12px',
                    background: '#f8faff',
                    width: '100%',
                    display: 'block',
                  }}>
                  <div
                    className="summary-vendor-header"
                    style={{ marginBottom: '15px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>
                    {vendor?.flagImg && <img src={vendor.flagImg} alt="" style={{ width: 18, height: 14 }} />}
                    <span style={{ fontSize: '13px', fontWeight: 700 }}>
                      {vendor?.label.toUpperCase()} - TIER {tierIdx + 1} ({qty} PCS)
                    </span>
                  </div>

                  {/* Using a grid to show labels in a single row for 100% width effect */}
                  <Grid xs={1} sm={3} lg={5} gap={20}>
                    <div className="summary-item">
                      <span className="label" style={{ fontSize: '10px' }}>
                        TOTAL COST
                      </span>
                      <span className="val" style={{ fontSize: '15px' }}>
                        {fmt(totalCost)}
                      </span>
                    </div>
                    <div className="summary-item">
                      <span className="label" style={{ fontSize: '10px' }}>
                        Cost PER Unit
                      </span>
                      <span className="val" style={{ fontSize: '15px' }}>
                        {fmt(costPerUnit)}
                      </span>
                    </div>
                    <div className="summary-item">
                      <span className="label" style={{ fontSize: '10px' }}>
                        Price per unit
                      </span>
                      <span className="val" style={{ fontSize: '15px' }}>
                        {fmt(pricePerUnit)}
                      </span>
                    </div>
                    <div className="summary-item">
                      <span className="label" style={{ fontSize: '10px' }}>
                        Profit
                      </span>
                      <span className="val" style={{ fontSize: '15px' }}>
                        {fmt(profit)}
                      </span>
                    </div>
                    <div className="summary-item final">
                      <span className="label" style={{ fontSize: '10px' }}>
                        Total amount
                      </span>
                      <span className="val" style={{ fontSize: '18px', color: '#15803d' }}>
                        {fmt(totalAmount)}
                      </span>
                    </div>
                  </Grid>
                </div>
              );
            });
          })}
          {(!item.selectedVendors || item.selectedVendors.length === 0) && (
            <div className="text-muted text-center p-4">Select a vendor to see summary</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EstimateItem;
